import { Component, Injectable, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { MailboxService } from '../../../../common/services/Mailbox.service';
import { EmailService } from '../../../../common/services/Email.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { environment } from 'environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadService } from '../../../../common/services/Upload.service';
import { SocketService } from '../../../../common/services/Socket.service';
import { forEach, include } from 'underscore';

declare var $: any;

@Component({
  templateUrl: './mailbox.component.html',
  styleUrls: ['./mailbox.css'],
  providers: [BsModalService, MailboxService, EmailService, UploadService],
})
@Injectable()
export class MailboxComponent implements OnInit {
  public no_image = 'assets/images/contact.png';
  @ViewChild('no_account') no_account: ElementRef;
  public user: any = {};
  public inbox: any = [];
  public account_id: any = 1;
  public account: any = {};
  public allAccount: any = [];
  public allFolder: any = [];
  public objFolder: any = {};
  public label = 'Hộp thư đến';
  public selected = 'inbox';
  public unread: any = 0;
  public loading = false;
  public modelFolder: any = {};
  public checked: any = {};
  public is_select_all = false;
  public modalRef: any;
  public selected_folder_id: number;
  public mode = 'list';
  public detail: any = {};
  public model: any = {};
  public files: any = [];
  public send_type = 'reply'; // reply, reply-all, sent, forward
  public message: { class: string; content: string } = null;
  public showFolder = false;

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  totalItem: any = 0;
  totalPage: any = 0;

  constructor(
    private toastr: ToastrService,
    private modalService: BsModalService,
    private mailboxService: MailboxService,
    private mailService: EmailService,
    private uploadService: UploadService,
    private socketService: SocketService,
    private router: Router
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.socketService.missionAnnounced$.subscribe(mission => {
      if (mission.action == 'new-email') {
        this.getUnread();
        if (this.selected == 'inbox' && this.currentPage == 1) {
          this.loadInbox();
        }
      }
    });
  }

  ngOnInit() {
    this.loadAccount();
  }

  changeSelect(selected, label, is_folder?: any) {
    this.selected = selected;
    this.label = label;

    this.selected_folder_id = null;
    this.currentPage = 1;
    this.totalRow = 0;
    this.page_size = 10;
    this.totalItem = 0;
    this.totalPage = 0;
    this.inbox = [];
    this.checked = {};
    this.is_select_all = false;
    this.mode = 'list';
    this.detail = {};

    if (is_folder) {
      this.selected_folder_id = selected;
      this.showFolder = true;
    }
    switch (selected) {
      case 'inbox': {
        this.loadInbox();
        break;
      }
      case 'delete': {
        this.loadInbox({ status: 'delete' });
        break;
      }
      case 'sent': {
        this.loadEmailSent();
        break;
      }
      case 'draft': {
        this.loadEmailSent({ status: 'draft' });
        break;
      }
      default: {
        this.loadInbox();
        break;
      }
    }
  }

  loadAccount() {
    this.mailService.listAccount().subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.allAccount = res.data;
        if (this.allAccount.length > 0) {
          this.account_id = this.allAccount[0].ID;
          this.account = this.allAccount[0];
          this.loadInbox();
          this.loadGroup();
          this.getUnread();
        } else {
          const config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
          };
          this.modalRef = this.modalService.show(this.no_account, config);
        }
      }
    });
  }

  changeAccount(account) {
    this.account_id = account.ID;
    this.account = account;
    this.changeSelect('inbox', 'Hộp thư đến', false);
    this.loadGroup();
    this.getUnread();
    this.showFolder = false;
  }

  redirectToSetting() {
    this.router.navigate(['/settings'], { queryParams: { force: 'email' } });
    this.modalRef.hide();
  }

  backToList() {
    this.detail = {};
    this.mode = 'list';
  }

  clickShowFolder() {
    this.showFolder = this.showFolder ? false : true;
  }

  viewEmail(mail_id, is_read?: boolean) {
    this.mailboxService.viewDetail(mail_id).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.mode = 'detail';
        this.detail = res.data;
        this.detail.email_to = this.detail.email_to ? this.detail.email_to.split(',') : [];
        this.detail.CC = this.detail.CC ? this.detail.CC.split(',') : [];
        this.detail.BCC = this.detail.BCC ? this.detail.BCC.split(',') : [];
        this.detail.ATTACH_FILE = this.detail.ATTACH_FILE ? this.detail.ATTACH_FILE.split(',') : [];

        if (is_read) {
          this.checked = {};
          this.checked[mail_id] = true;
          this.setRead(is_read);
        }
      }
    });
  }

  viewEmailSent(mail_id) {
    this.mailboxService.viewDetailSent(mail_id).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.mode = 'detail';
        this.detail = res.data;
        this.detail.email_to = this.detail.email_to ? this.detail.email_to.split(',') : [];
        this.detail.CC = this.detail.CC ? this.detail.CC.split(',') : [];
        this.detail.BCC = this.detail.BCC ? this.detail.BCC.split(',') : [];
        this.detail.ATTACH_FILE = this.detail.ATTACH_FILE ? this.detail.ATTACH_FILE.split(',') : [];
      }
    });
  }

  sendMail() {
    let TO = '';
    let CC = '';
    let BCC = '';
    let FILES = '';
    this.message = null;
    let content_type = 1;
    if (this.model.TO && this.model.TO.length > 0) {
      const tmp_TO = _.map(this.model.TO, e => {
        return e.displayValue;
      });
      TO = tmp_TO.join(',');
    }
    if (this.model.CC && this.model.CC.length > 0) {
      const tmp_CC = _.map(this.model.CC, e => {
        return e.displayValue;
      });
      CC = tmp_CC.join(',');
    }
    if (this.model.BCC && this.model.BCC.length > 0) {
      const tmp_BCC = _.map(this.model.BCC, e => {
        return e.displayValue;
      });
      BCC = tmp_BCC.join(',');
    }

    if (this.model.ATTACH_FILE && this.model.ATTACH_FILE.length > 0) {
      FILES = this.model.ATTACH_FILE.join(',');
      content_type = 3;
    }
    const body = {
      emailSentId: this.account_id,
      emailFrom: this.account.EMAIL_ADDRESS,
      emailTo: TO,
      subject: this.model['SUBJECT'],
      cc: CC,
      bcc: BCC,
      attachFile: FILES,
      requestTime: null,
      content: this.model['CONTENT'],
      contentType: content_type,
      agentUsername: this.user.email,
      emailMsgId: null,
      emailId: this.detail['EMAIL_ID'] || null, // co luoong mail thi gui lai
      fromAgent: null, // co luong mail thif day
    };
    if (this.selected == 'sent' || this.selected == 'draft') {
      body['fromAgent'] = this.detail['FROM_AGENT'];
    } else {
      body['fromAgent'] = this.detail['AGENTS'];
    }
    if (
      body.content &&
      body.content.trim() != '' &&
      body.emailFrom &&
      body.emailFrom.trim() != '' &&
      body.emailTo &&
      body.emailTo.trim() != '' &&
      body.emailSentId
    ) {
      if (this.send_type == 'sent') {
        this.mailboxService.postFullUrl(environment.url_email + '/sentemail', body).subscribe(res => {
          if (res.status == 'OK') {
            this.modalRef.hide();
            this.toastr.success('Đã gửi mail', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Gửi mail không thành công',
            };
          }
        });
      } else if (this.send_type == 'reply' || this.send_type == 'reply-all') {
        this.mailboxService.postFullUrl(environment.url_email + '/reply', body).subscribe(res => {
          if (res.status == 'OK') {
            this.modalRef.hide();
            this.toastr.success('Đã Reply mail', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Gửi mail không thành công',
            };
          }
        });
      } else if (this.send_type == 'forward') {
        this.mailboxService.postFullUrl(environment.url_email + '/forward', body).subscribe(res => {
          if (res.status == 'OK') {
            this.modalRef.hide();
            this.toastr.success('Đã Forward mail', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Gửi mail không thành công',
            };
          }
        });
      }
    }
  }

  loadEmailSent(request: any = {}, sort: any = {}) {
    request['account_email'] = this.account.EMAIL_ADDRESS;
    this.loading = true;
    this.inbox = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.mailboxService
      .listSentMail(request)
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.inbox = res.data.emails;
          this.totalItem = res.data.total;
          const pageString = (this.totalItem / this.page_size).toString();
          const pageSplit = pageString.split('.');
          let last: any;
          let totalpage = parseInt(pageSplit[0]);
          if (pageSplit.length > 1) {
            last = pageSplit[1];
            if (parseInt(last) > 0) {
              totalpage++;
            }
          }
          this.totalPage = totalpage;
        }
        this.loading = false;
      });
  }

  getUnread() {
    this.mailboxService.unread(this.account_id).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.unread = res.data;
      }
    });
  }
  loadGroup() {
    this.mailboxService.getFolders(this.account_id).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.allFolder = res.data;
        this.allFolder.forEach(element => {
          this.objFolder[element.folder_id] = element;
        });
      }
    });
  }
  loadInbox(request: any = {}, sort: any = {}) {
    this.loading = true;
    this.inbox = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    if (this.selected_folder_id) {
      request['folder_id'] = this.selected_folder_id;
    }
    this.mailboxService
      .inbox(this.account_id, request)
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.inbox = res.data.emails;
          this.inbox.forEach(email => {
            if (include(email.SHORT_CONTENT, '<html>')) {
              email.SHORT_CONTENT = '[html content email]';
            }
          });
          this.totalItem = res.data.total;
          const pageString = (this.totalItem / this.page_size).toString();
          const pageSplit = pageString.split('.');
          let last: any;
          let totalpage = parseInt(pageSplit[0]);
          if (pageSplit.length > 1) {
            last = pageSplit[1];
            if (parseInt(last) > 0) {
              totalpage++;
            }
          }
          this.totalPage = totalpage;
        }
        this.loading = false;
      });
  }

  changeSelectAll() {
    this.inbox.forEach(e => {
      if (this.selected == 'sent' || this.selected == 'draft') {
        this.checked[e.EMAIL_SENT_ID] = this.is_select_all;
      } else {
        this.checked[e.EMAIL_ID] = this.is_select_all;
      }
    });
  }

  setRead(is_read) {
    const ids = [];
    this.inbox.forEach(e => {
      if (this.selected != 'sent' && this.selected != 'draft') {
        if (this.checked[e.EMAIL_ID]) {
          ids.push(e.EMAIL_ID);
        }
      }
    });
    if (ids.length > 0) {
      const payload = {
        ids: ids,
        is_read: is_read,
      };
      this.mailboxService.setRead(payload).subscribe(res => {
        if (res.status == 200 && !res.error) {
          this.loadInbox();
        }
      });
    }
  }

  setDelete() {
    const ids = [];
    this.inbox.forEach(e => {
      if (this.checked[e.EMAIL_ID]) {
        ids.push(e.EMAIL_ID);
      }
    });
    if (ids.length > 0) {
      const payload = {
        ids: ids,
      };
      this.mailboxService.setDelete(payload).subscribe(res => {
        if (res.status == 200 && !res.error) {
          this.loadInbox();
        }
      });
    } else {
      this.toastr.warning('Chưa chọn thư cần xóa', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  setDeleteForever() {
    const ids = [];
    this.inbox.forEach(e => {
      if (this.checked[e.EMAIL_ID]) {
        ids.push(e.EMAIL_ID);
      }
    });
    if (ids.length > 0) {
      const payload = {
        ids: ids,
      };
      this.mailboxService.setDeleteForever(payload).subscribe(res => {
        if (res.status == 200 && !res.error) {
          this.loadInbox({ status: 'delete' });
        }
      });
    } else {
      this.toastr.warning('Chưa chọn thư cần xóa', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  setDeleteSent() {
    const ids = [];
    this.inbox.forEach(e => {
      if (this.checked[e.EMAIL_SENT_ID]) {
        ids.push(e.EMAIL_SENT_ID);
      }
    });
    if (ids.length > 0) {
      const payload = {
        ids: ids,
      };
      this.mailboxService.setDeleteSent(payload).subscribe(res => {
        if (res.status == 200 && !res.error) {
          if (this.selected == 'sent') {
            this.loadEmailSent();
          } else if (this.selected == 'draft') {
            this.loadEmailSent({ status: 'draft' });
          }
        }
      });
    } else {
      this.toastr.warning('Chưa chọn thư cần xóa', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }
  setDeleteForeverSent() {
    const ids = [];
    this.inbox.forEach(e => {
      if (this.checked[e.EMAIL_SENT_ID]) {
        ids.push(e.EMAIL_SENT_ID);
      }
    });
    if (ids.length > 0) {
      const payload = {
        ids: ids,
      };
      this.mailboxService.setDeleteForeverSent(payload).subscribe(res => {
        if (res.status == 200 && !res.error) {
          if (this.selected == 'sent') {
            this.loadEmailSent();
          } else if (this.selected == 'draft') {
            this.loadEmailSent({ status: 'draft' });
          }
        }
      });
    } else {
      this.toastr.warning('Chưa chọn thư cần xóa', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  deleteFromSystem(template: TemplateRef<any>, id?: any) {
    if (this.selected == 'delete') {
      const ids = [];
      this.inbox.forEach(e => {
        if (this.checked[e.EMAIL_ID]) {
          ids.push(e.EMAIL_ID);
        }
      });
      if (ids.length > 0) {
        const config = {
          backdrop: true,
          ignoreBackdropClick: true,
          keyboard: false,
        };
        this.modalRef = this.modalService.show(template, config);
      } else {
        this.toastr.warning('Chưa chọn thư cần xóa', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    } else if (this.selected == 'draft') {
      const ids = [];
      this.inbox.forEach(e => {
        if (this.checked[e.EMAIL_SENT_ID]) {
          ids.push(e.EMAIL_SENT_ID);
        }
      });
      if (ids.length > 0) {
        const config = {
          backdrop: true,
          ignoreBackdropClick: true,
          keyboard: false,
        };
        this.modalRef = this.modalService.show(template, config);
      } else {
        this.toastr.warning('Chưa chọn thư cần xóa', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    }
  }

  openModal(template: TemplateRef<any>, id?: any) {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  openModalLarge(template: TemplateRef<any>, id?: any) {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  initMail(type, detail) {
    this.send_type = type;
    this.model = { TO: [], CC: [], BCC: [] };
    this.message = null;
    this.model['FROM'] = this.account.EMAIL_ADDRESS;
    switch (this.send_type) {
      case 'sent': {
        break;
      }
      case 'reply': {
        this.model['TO'] = detail['email_from'] ? [detail['email_from']] : [];
        this.model['SUBJECT'] = detail['EMAIL_SUBJECT'] ? 'Reply-' + detail['EMAIL_SUBJECT'] : '';
        this.model['TO'] = _.map(this.model['TO'], e => {
          return {
            displayValue: e,
          };
        });
        break;
      }
      case 'reply-all': {
        this.model['TO'] = detail['email_from'] ? [detail['email_from']] : [];
        this.model['SUBJECT'] = detail['EMAIL_SUBJECT'] ? 'Reply-' + detail['EMAIL_SUBJECT'] : '';
        this.model['CC'] = detail['CC'] ? detail['CC'] : [];
        this.model['BCC'] = detail['BCC'] ? detail['BCC'] : [];
        this.model['TO'] = _.map(this.model['TO'], e => {
          return {
            displayValue: e,
          };
        });
        this.model['CC'] = _.map(this.model['CC'], e => {
          return {
            displayValue: e,
          };
        });
        this.model['BCC'] = _.map(this.model['BCC'], e => {
          return {
            displayValue: e,
          };
        });
        break;
      }
      case 'forward': {
        this.model['SUBJECT'] = detail['EMAIL_SUBJECT'] ? detail['EMAIL_SUBJECT'] : '';
        this.model['CONTENT'] = detail['CONTENT'] ? detail['CONTENT'] : '';
        this.model['ATTACH_FILE'] = detail['ATTACH_FILE'] ? detail['ATTACH_FILE'] : [];
        break;
      }
      default:
        break;
    }
    // this.model['TO'] = detail['TO'] ? detail['TO']: [];
    // this.model['CC'] = detail['CC'] ? detail['CC'] : [];
    // this.model['BCC'] = detail['BCC'] ? detail['BCC'] : [];
    // this.model['SUBJECT'] = detail['SUBJECT'] ? 'Reply-'+detail['SUBJECT']: '';
    // this.model['CONTENT'] = detail['CONTENT'] ? detail['CONTENT']: '';
    // this.model['ATTACH_FILE'] = detail['ATTACH_FILE'] ? detail['ATTACH_FILE']:[];
  }

  attachFile($event) {
    const files = $event.srcElement.files;
    this.uploadService.upload(files[0]).then((res: any) => {
      if (!res.error) {
        if (this.model['ATTACH_FILE']) {
          this.model['ATTACH_FILE'].push(res.data);
        } else {
          this.model['ATTACH_FILE'] = [res.data];
        }
        $event.target.value = null;
      } else {
        this.toastr.error(res.data.message, 'Lỗi', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }
  deleteFile(file) {
    this.model['ATTACH_FILE'] = _.pull(this.model['ATTACH_FILE'], file);
  }

  openFile() {
    (<any>$('#file')).trigger('click');
  }

  submitDelete() {
    if (this.selected == 'delete') {
      this.setDeleteForever();
    } else if (this.selected == 'draft') {
      this.setDeleteForeverSent();
    }
  }

  setFolder(folder_id) {
    const ids = [];
    this.inbox.forEach(e => {
      if (this.selected == 'sent' || this.selected == 'draft') {
        if (this.checked[e.EMAIL_SENT_ID]) {
          ids.push(e.EMAIL_SENT_ID);
        }
      } else {
        if (this.checked[e.EMAIL_ID]) {
          ids.push(e.EMAIL_ID);
        }
      }
    });
    if (ids.length > 0) {
      this.mailboxService.addMailFolder({ ids: ids, folder_id: folder_id }).subscribe(res => {
        if (res.status == 200 && !res.error) {
          this.loadInbox();
        }
      });
    }
  }

  addFolder() {
    this.mailboxService.createFolder(this.account_id, this.modelFolder).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.loadGroup();
      }
    });
  }
  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadInbox();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadInbox();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  handleCloseMailModal() {
    let TO = '';
    let CC = '';
    let BCC = '';
    let FILES = '';
    this.message = null;
    let content_type = 1;
    if (this.model.TO && this.model.TO.length > 0) {
      const tmp_TO = _.map(this.model.TO, e => {
        return e.displayValue;
      });
      TO = tmp_TO.join(',');
    }
    if (this.model.CC && this.model.CC.length > 0) {
      const tmp_CC = _.map(this.model.CC, e => {
        return e.displayValue;
      });
      CC = tmp_CC.join(',');
    }
    if (this.model.BCC && this.model.BCC.length > 0) {
      const tmp_BCC = _.map(this.model.BCC, e => {
        return e.displayValue;
      });
      BCC = tmp_BCC.join(',');
    }

    if (this.model.ATTACH_FILE && this.model.ATTACH_FILE.length > 0) {
      FILES = this.model.ATTACH_FILE.join(',');
      content_type = 3;
    }
    const body = {
      emailSentId: this.account_id,
      emailFrom: this.account.EMAIL_ADDRESS,
      emailTo: TO,
      subject: this.model['SUBJECT'],
      cc: CC,
      bcc: BCC,
      attachFile: FILES,
      requestTime: null,
      content: this.model['CONTENT'],
      contentType: content_type,
      agentUsername: this.user.email,
      emailMsgId: null,
      emailId: this.detail['EMAIL_ID'] || null, // co luoong mail thi gui lai
      fromAgent: null, // co luong mail thif day
    };
    if (this.selected == 'sent' || this.selected == 'draft') {
      body['fromAgent'] = this.detail['FROM_AGENT'];
    } else {
      body['fromAgent'] = this.detail['AGENTS'];
    }
    if (
      ((body.content && body.content.trim() != '') ||
        (body.cc && body.cc.trim() != '') ||
        (body.bcc && body.bcc.trim() != '') ||
        (body.subject && body.subject.trim() != '') ||
        (body.emailTo && body.emailTo.trim() != '') ||
        body.attachFile) &&
      body.emailFrom &&
      body.emailFrom.trim() != ''
    ) {
    }
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/email/mailbox.component.ts